import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable'
import { Headers } from '@angular/http';
import { Http } from '@angular/http';
import { CookieService } from 'ngx-cookie-service';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import * as CryptoJS from 'crypto-js';
import { FlavourDomainService } from './flavour-domain.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { SessionExpiredService } from './sessionExpired.service';

@Injectable({ providedIn: 'root' })
export class HttpClientService {

    public authToken;

    constructor(private httpClient: HttpClient, private http: Http, private cookieService: CookieService, private FlavourDomain: FlavourDomainService, private sessionExpired: SessionExpiredService) { }


    public hmacConvert(method, data) {
        var hmacKey = '/&+@spJ8;*x+%4(9%P_n=Fu[a()F^%t.<P5sqHEp5~a.<M{hFa';

        var string = '';
        string = `${hmacKey}-${method}-${data !== "" ? JSON.stringify(data) : ""}`

        var hash = CryptoJS.HmacSHA256(string, hmacKey);
        var hashInBase64 = CryptoJS.enc.Base64.stringify(hash);
        console.log('hashInBase64', hashInBase64);
        return hashInBase64;
    }

    createAuthorizationHeader(headers: Headers, signKey: string) {
        this.authToken = this.cookieService.get('token');
        if (this.cookieService.get('deviceInfo')) {

            var deviceInfo = JSON.parse(this.cookieService.get('deviceInfo'));
        }

        headers.append('Content-Type', 'application/json');
        headers.append('Accept', 'application/json');
        headers.append('Authorization', 'token ' + this.authToken);
        if (this.cookieService.get('deviceInfo')) {

            headers.append('browser-name', deviceInfo.browser);
            headers.append('browser-version', deviceInfo.browser_version);
            headers.append('platform', deviceInfo.os);
        }
        headers.append('Signing-Key', signKey);
        headers.append('app', this.FlavourDomain.domain().key);
    }


    createAuthorizationHeadercontent(headers: Headers, signKey: string) {
        this.authToken = this.cookieService.get('token');
        if (this.cookieService.get('deviceInfo')) {

            var deviceInfo = JSON.parse(this.cookieService.get('deviceInfo'));
        }

        headers.append('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');
        headers.append('Accept', 'application/json');
        headers.append('Authorization', 'token ' + this.authToken);
        if (this.cookieService.get('deviceInfo')) {

            headers.append('browser-name', deviceInfo.browser);
            headers.append('browser-version', deviceInfo.browser_version);
            headers.append('platform', deviceInfo.os);
        }
        headers.append('Signing-Key', signKey);
        headers.append('app', this.FlavourDomain.domain().key);
    }

    createUcmsAuthorizationHeader(headers: Headers, signKey: string) {
        this.authToken = this.cookieService.get('token');

        headers.append('Content-Type', 'application/json');
        headers.append('Authorization', 'Token 496029BF-4793-44B7-AAC0-1D53CCB0323C');
        headers.append('_WPOSUBSCRIBER', 'ALLYH');
        headers.append('Signing-Key', signKey);

    }
    createWpoAuthorizationHeader(headers: Headers, signKey: string) {
        headers.append('Content-Type', 'application/json');
        headers.append('Ocp-Apim-Subscription-Key', 'aae8b416935045b0b081248273571653');
        headers.append('Signing-Key', signKey);
    }
    contentheaderSet(headers: Headers) {
        headers.append('Content-Type', 'application/x-www-form-urlencoded; charset=utf-8');

    }

    createAuthorizationHeaderFormdat(headers: Headers, signKey) {
        this.authToken = this.cookieService.get('token');
        if (this.cookieService.get('deviceInfo')) {

            var deviceInfo = JSON.parse(this.cookieService.get('deviceInfo'));
        }

        headers.append('Content-Type', 'multipart/form-data');
        headers.append('Content-Type', 'application/json');
        headers.append('Accept', 'application/json');
        headers.delete('Content-Type');
        headers.append('Authorization', 'token ' + this.authToken);
        if (this.cookieService.get('deviceInfo')) {

            headers.append('browser-name', deviceInfo.browser);
            headers.append('browser-version', deviceInfo.browser_version);
            headers.append('platform', deviceInfo.os);
        }
        headers.append('Signing-Key', signKey);
        headers.append('app', this.FlavourDomain.domain().key);
    }


    createAuthorizationHeaderFormdatWithoutAuth(headers: Headers, signKey: string) {

        headers.append('Content-Type', 'multipart/form-data');
        headers.append('Content-Type', 'application/json');
        headers.append('Accept', 'application/json');
        headers.delete('Content-Type');

        headers.append('Signing-Key', signKey);

    }


    createAuthorizationHeaderwithoutToken(headers: Headers, signKey: string) {
        if (this.cookieService.get('deviceInfo')) {

            var deviceInfo = JSON.parse(this.cookieService.get('deviceInfo'));
        }
        headers.append('Content-Type', 'application/json');
        headers.append('Accept', 'application/json');
        if (this.cookieService.get('deviceInfo')) {

            headers.append('browser-name', deviceInfo.browser);
            headers.append('browser-version', deviceInfo.browser_version);
            headers.append('platform', deviceInfo.os);
        }

        headers.append('Signing-Key', signKey);
        headers.append('app', this.FlavourDomain.domain().key);

    }

    createAuthorizationHeaderwithoutMDliveToken(headers: Headers, signKey: string) {
        headers.append('Content-Type', 'application/json');
        headers.append('Accept', 'application/json');
        headers.append('app', 'BN');
        headers.append('Signing-Key', signKey);

    }

    createAuthorizationHeaderwithMDlivetoken(headers: Headers, signKey: string) {
        var mdlive = JSON.parse(this.cookieService.get('mdlive'));
        headers.append('Content-Type', 'multipart/form-data');
        headers.append('Content-Type', 'application/json');
        headers.append('Accept', 'application/json');
        headers.delete('Content-Type');
        headers.append('Authorization', 'Bearer ' + mdlive.m_jwt_token);
        headers.append('app', 'BN');
        headers.append('Signing-Key', signKey);

    }

    createAuthorizationHeaderwithoutDDNToken(headers: Headers, signKey: string) {
        headers.append('Content-Type', 'application/json');
        headers.append('Accept', 'application/json');
        headers.append('Signing-Key', signKey);

    }

    createAuthorizationHeaderwithDDNtoken(headers: Headers, signKey: string) {

        var DDNToken = this.cookieService.get('ddnToken');
        headers.append('Content-Type', 'multipart/form-data');

        headers.append('Content-Type', 'application/json');
        headers.append('Accept', 'application/json');
        headers.delete('Content-Type');
        headers.append('Authorization', 'Bearer ' + DDNToken);
        headers.append('Signing-Key', signKey);


    }

    createAuthorizationHeaderforBeforeLogin(headers: HttpHeaders, signKey: string): HttpHeaders {
        this.authToken = this.cookieService.get('token');

        // HttpHeaders are immutable, so you must reassign each time you append a header
        headers = headers.set('Content-Type', 'application/json');
        headers = headers.set('Accept', 'application/json');
        headers = headers.set('Signing-Key', signKey);


        return headers; // Return the modified headers
    }
    createAuthorizationLyricToken3(headers: HttpHeaders, signKey: string): HttpHeaders {
        let data = localStorage.getItem("lyricData");
        const lyricToken = JSON.parse(data).lyric_usertoken || ""; // Use optional chaining
        headers.append('Signing-Key', signKey);

        // Return a new HttpHeaders instance with the Authorization header
        return headers.append('Authorization', 'Bearer ' + lyricToken);
    }
    // getLyricWithToken2(url: string): Observable<Blob> {
    //     const headers = new HttpHeaders(); // Use HttpHeaders
    //     this.createAuthorizationLyricToken3(headers); // Modify headers as needed

    //     return this.http.get(url, {
    //       headers: headers,
    //       responseType: 'blob' // Specify response type
    //     });
    //   }


    createAuthorizationLyricToken2(headers: HttpHeaders, signKey: string): HttpHeaders {
        const data = localStorage.getItem("lyricData");
        const lyricToken = JSON.parse(data) ? JSON.parse(data).lyric_usertoken : "";
        headers.append('Signing-Key', signKey);

        return headers.set('Authorization', 'Bearer ' + lyricToken);
    }
    // get(url) 
    // {
    //    const headers = new Headers(); 
    //    let hKey = this.hmacConvert('GET','');
    //    this.createAuthorizationHeader(headers,hKey); 
    //    return this.http.get(url, 
    //        {
    //            headers: headers,
    //        }
    //    )
    //    .map(res => res.json());
    // }
    createAuthorizationHeader2(headers: HttpHeaders, signKey: string): HttpHeaders {
        this.authToken = this.cookieService.get('token');

        // HttpHeaders are immutable, so you must reassign each time you append a header
        headers = headers.set('Content-Type', 'application/json');
        headers = headers.set('Accept', 'application/json');
        headers = headers.set('Authorization', 'token ' + this.authToken);
        headers = headers.set('Signing-Key', signKey);
        headers = headers.set('app', this.FlavourDomain.domain().key);

        return headers; // Return the modified headers
    }


    getLangFromHash() {
        // Get everything after the # symbol
        const hash = window.location.hash; // e.g., "#/?lang=es"

        // Create a URLSearchParams object from the query string in the hash
        const queryString = hash.split('?')[1].split('=')[1]; // get part after '?', e.g., "lang=es"

        return queryString;
    }

    createAuthorizationHeaderwithoutTokenLanguage(headers: Headers, signKey: string) {
        if (this.cookieService.get('deviceInfo')) {

            var deviceInfo = JSON.parse(this.cookieService.get('deviceInfo'));
        }
        headers.append('Content-Type', 'application/json');
        headers.append('Accept', 'application/json');
        if (this.cookieService.get('deviceInfo')) {

            headers.append('browser-name', deviceInfo.browser);
            headers.append('browser-version', deviceInfo.browser_version);
            headers.append('platform', deviceInfo.os);
        }

        headers.append('Signing-Key', signKey);
        headers.append('app', this.FlavourDomain.domain().key);
        headers.append('language', this.getLangFromHash());

    }

    PostLoginLanguage(url, data) {
        const headers = new Headers();
        let hKey = this.hmacConvert('POST', data);
        this.createAuthorizationHeaderwithoutTokenLanguage(headers, hKey);
        return this.http.post(url, data,
            {
                headers: headers,
            }
        )
            .map(res => res.json());
    }

    PostLogin(url, data) {
        const headers = new Headers();
        let hKey = this.hmacConvert('POST', data);
        this.createAuthorizationHeaderwithoutToken(headers, hKey);
        return this.http.post(url, data,
            {
                headers: headers,
            }
        )
            .map(res => res.json());
    }

    postWithBlobWithoutAuth(url: string, data?: any): Observable<Blob> {
        let headers = new HttpHeaders();
        const hKey = this.hmacConvert('POST', data || '');
        headers = this.createAuthorizationHeaderforBeforeLogin(headers, hKey);

        return this.httpClient.post(url, data || {}, {
            headers: headers,
            responseType: 'blob'
        });
    }

    putImage(url, data) {
        const headers = new Headers();
        let hKey = this.hmacConvert('PUT', data);
        this.createAuthorizationHeaderFormdat(headers, hKey);
        return this.http.put(url, data,
            {
                headers: headers,
            }
        )
            .map(res => res.json())
            .catch(err => this.sessionExpired.handle(err));
    }

    postImage(url, data) {
        const headers = new Headers();
        let hKey = this.hmacConvert('POST', data);
        this.createAuthorizationHeaderFormdat(headers, hKey);
        return this.http.post(url, data,
            {
                headers: headers,
            }
        )
            .map(res => res.json())
            .catch(err => this.sessionExpired.handle(err));
    }
    postImageWithoutAuth(url: any, data: any) {
        const headers = new Headers();
        let hKey = this.hmacConvert('POST', data);
        this.createAuthorizationHeaderFormdatWithoutAuth(headers, hKey);
        return this.http.post(url, data,
            {
                headers: headers,
            }
        )
            .map(res => res.json());
    }

    getWT(url) {
        const headers = new Headers();
        let hKey = this.hmacConvert('GET', '');
        this.createAuthorizationHeaderwithoutToken(headers, hKey);
        return this.http.get(url,
            {
                headers: headers,
            }
        )
            .map(res => res.json());
    }

    get(url) {
        const headers = new Headers();
        let hKey = this.hmacConvert('GET', '');
        this.createAuthorizationHeader(headers, hKey);
        return this.http.get(url,
            {
                headers: headers,
            }
        )
            .map(res => res.json())
            .catch(err => this.sessionExpired.handle(err));
    }




    getUcms(url) {
        const headers = new Headers();
        let hKey = this.hmacConvert('POST', '');
        this.createUcmsAuthorizationHeader(headers, hKey);
        return this.http.get(url,
            {
                headers: headers,
            }
        )
            .map(res => res.json());
    }
    postUcms(url, data) {
        const headers = new Headers();
        let hKey = this.hmacConvert('POST', data);
        this.createUcmsAuthorizationHeader(headers, hKey);
        return this.http.post(url, data,
            {
                headers: headers,
            }
        )
            .map(res => res.json());
    }

    postWpo(url, data) {
        const headers = new Headers();
        let hKey = this.hmacConvert('POST', data);
        this.createWpoAuthorizationHeader(headers, hKey);
        return this.http.post(url, data,
            {
                headers: headers,
            }
        )
            .map(res => res.json());
    }

    // postContent(url, data){
    //     return this.http.post(url, data)
    //     .map(res => res.json());
    // }
    postContent(url, data) {
        const headers = new Headers();
        let hKey = this.hmacConvert('POST', data);
        this.createAuthorizationHeader(headers, hKey);
        return this.http.post(url, data,
            {
                headers: headers,
            }
        )
            .map(res => res.json())
            .catch(err => this.sessionExpired.handle(err));
    }
    // postContentwithHeader(url, data){
    //     const headers = new Headers(); 
    //     this.contentheaderSet(headers)
    //     return this.http.post(url, data,{
    //         headers: headers,
    //         })
    //     .map(res => res.json());
    // }
    postContentwithHeader(url, data) {
        const headers = new Headers();
        let hKey = this.hmacConvert('POST', data);
        this.createAuthorizationHeadercontent(headers, hKey);
        return this.http.post(url, data,
            {
                headers: headers,
            }
        )
            .map(res => res.json())
            .catch(err => this.sessionExpired.handle(err));
    }


    get_lat_log_zipcode(url) {
        const headers = new Headers();
        return this.http.get(url,
            {
                headers: headers,
            }
        )
            .map(res => res.json());
    }

    post(url, data) {
        const headers = new Headers();
        let hKey = this.hmacConvert('POST', data);
        this.createAuthorizationHeader(headers, hKey);
        return this.http.post(url, data,
            {
                headers: headers,
            }
        )
            .map(res => res.json())
            .catch(err => this.sessionExpired.handle(err));
    }

    put(url, data) {
        const headers = new Headers();
        let hKey = this.hmacConvert('PUT', data);
        this.createAuthorizationHeader(headers, hKey);
        return this.http.put(url, data,
            {
                headers: headers,
            }
        )
            .map(res => res.json())
            .catch(err => this.sessionExpired.handle(err));
    }

    delete(url) {
        const headers = new Headers();
        let hKey = this.hmacConvert('DELETE', '');
        this.createAuthorizationHeader(headers, hKey);
        return this.http.delete(url,
            {
                headers: headers,
            }
        )
            .map(res => res.json())
            .catch(err => this.sessionExpired.handle(err));
    }

    /*********************************MDliive*************************************************************** */
    getM(url) {
        const headers = new Headers();
        let hKey = this.hmacConvert('GET', '');
        this.createAuthorizationHeader(headers, hKey);
        return this.http.get(url,
            {
                headers: headers,
            }
        )
            .map(res => res.json())
            .catch(err => this.sessionExpired.handle(err));

    }

    postM(url, data) {
        const headers = new Headers();
        let hKey = this.hmacConvert('POST', data);
        this.createAuthorizationHeader(headers, hKey);
        return this.http.post(url, data,
            {
                headers: headers,
            }
        )
            .map(res => res.json())
            .catch(err => this.sessionExpired.handle(err));
    }
    putM(url, data) {
        const headers = new Headers();
        let hKey = this.hmacConvert('PUT', data);
        this.createAuthorizationHeader(headers, hKey);
        return this.http.put(url, data,
            {
                headers: headers,
            }
        )
            .map(res => res.json())
            .catch(err => this.sessionExpired.handle(err));
    }
    patchM(url, data) {
        const headers = new Headers();
        let hKey = this.hmacConvert('PATCH', data);
        this.createAuthorizationHeader(headers, hKey);
        return this.http.patch(url, data, {
            headers: headers,
        })
            .map(res => res.json())
            .catch(err => this.sessionExpired.handle(err));
    }



    deleteM(url) {
        const headers = new Headers();
        let hKey = this.hmacConvert('DELETE', '');
        this.createAuthorizationHeader(headers, hKey);
        return this.http.delete(url,
            {
                headers: headers,
            }
        )
            .map(res => res.json())
            .catch(err => this.sessionExpired.handle(err));
    }


    postMwithOutToken(url, data) {
        const headers = new Headers();
        let hKey = this.hmacConvert('POST', data);
        this.createAuthorizationHeaderwithoutMDliveToken(headers, hKey);
        return this.http.post(url, data,
            {
                headers: headers,
            }
        )
            .map(res => res.json());
    }

    // ********************************DDN***************************************************
    getDwithOutToken(url, data) {
        const headers = new Headers();
        let hKey = this.hmacConvert('GET', data);
        this.createAuthorizationHeaderwithoutDDNToken(headers, hKey);
        return this.http.post(url, data,
            {
                headers: headers,
            }
        )
            .map(res => res.json());
    }


    getD(url) {
        const headers = new Headers();
        let hKey = this.hmacConvert('GET', '');
        this.createAuthorizationHeaderwithDDNtoken(headers, hKey);
        return this.http.get(url,
            {

                headers: headers,
            }
        )
            .map(res => res.json());
    }


    createAuthorizationLyricToken(headers: Headers, signKey: string) {
        let data = localStorage.getItem("lyricData");
        var lyricToken = JSON.parse(data) ? JSON.parse(data).lyric_usertoken : "";
        headers.append('Signing-Key', signKey);

        headers.append('Authorization', 'Bearer ' + lyricToken);

    }


    getLyricWithToken(url) {
        const headers = new Headers();
        let hKey = this.hmacConvert('GET', '');
        this.createAuthorizationLyricToken(headers, hKey);
        return this.http.get(url,
            {
                headers: headers,
            }
        )
            .map(res => res.json());
    }

    getImage(url: string): Observable<Blob> {
        let headers = new HttpHeaders();
        let hKey = this.hmacConvert('GET', '');
        headers = this.createAuthorizationHeader2(headers, hKey);

        return this.httpClient.get(url, {
            headers: headers,
            responseType: 'blob'  // Indicate we expect binary data (blob)
        });
    }
    //   getImagePdf(url: string): Observable<Blob> {
    //     let headers = new HttpHeaders();
    //     let hKey = this.hmacConvert('GET', '');
    //     headers = this.createAuthorizationHeader2(headers); 

    //     return this.httpClient.get(url, {
    //       headers: headers,
    //       responseType: 'blob'  // Indicate we expect binary data (blob)
    //     });
    //   }


    postLyricWithToken(url, data) {
        const headers = new Headers();
        let hKey = this.hmacConvert('POST', data);
        this.createAuthorizationLyricToken(headers, hKey);
        return this.http.post(url, data,
            {
                headers: headers,
            }
        )
            .map(res => res.json());

    }

    postWithBlob(url: string, data?: any): Observable<Blob> {
        let headers = new HttpHeaders();
        const hKey = this.hmacConvert('POST', data || '');
        headers = this.createAuthorizationHeader2(headers, hKey);

        return this.httpClient.post(url, data || {}, {
            headers: headers,
            responseType: 'blob'
        });
    }
}